var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-sidebar-right",class:{ 'layout-sidebar-right-active': _vm.rightMenuActive },on:{"click":_vm.rightMenuClick}})}
var staticRenderFns = []

export { render, staticRenderFns }